import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './References.css';

function References() {
  return (
    <section className="references py-4">
      <Container fluid="lg">
        <Row>
          <Col className="text-center">
            <h2>References</h2>
          </Col>
        </Row>
        <Row className="mt-4">
          {/* Colonna 1: RETAILS / SERVICES */}
          <Col lg={4} md={6} sm={12} className="references-col text-center border-col-right">
            <h6>RETAILS / SERVICES</h6>
            <img src="/References/Immagine1.png" alt="Culti Milano" className="ref-logo" />
            <img src="/References/Immagine2.png" alt="Farmacie Zaccariello" className="ref-logo" />
            <img src="/References/Immagine3.jpg" alt="Fratelli Cutolo" className="ref-logo" />
            <img src="/References/Immagine4.jpg" alt="Solitek" className="ref-logo" />
          </Col>
          {/* Colonna 2: TECHNICAL PARTNERS */}
          <Col lg={4} md={6} sm={12} className="references-col text-center border-col-right border-col-left">
            <h6>TECHNICAL PARTNERS</h6>
            <img src="/References/Immagine5.png" alt="Architecture Design Hub" className="ref-logo" />
            <img src="/References/Immagine6.png" alt="Italia Power" className="ref-logo" />
            <img src="/References/Immagine7.jpg" alt="In Corpus" className="ref-logo" />
            <img src="/References/LogoIndes.png" alt="Indes" className="ref-logo" />
          </Col>
          {/* Colonna 3: INSTITUTIONAL CLIENTS / PARTNERS */}
          <Col lg={4} md={12} sm={12} className="references-col text-center border-col-left">
            <h6>INSTITUTIONAL CLIENTS / PARTNERS</h6>
            <div className="institutional-grid">
              <img src="/References/Immagine8.jpg" alt="Tangenziale Napoli" className="ref-logo" />
              <img src="/References/Immagine9.png" alt="Regione Campania" className="ref-logo" />
              <img src="/References/Immagine10.png" alt="Studi di Napoli" className="ref-logo" />
              <img src="/References/Immagine11.png" alt="Federico II" className="ref-logo" />
              <img src="/References/Immagine12.png" alt="CNR ISMAR" className="ref-logo" />
              <img src="/References/Immagine13.png" alt="Comune di Portici" className="ref-logo" />
              <img src="/References/Immagine14.jpg" alt="Provincia di Roma" className="ref-logo" />
              <img src="/References/Immagine15.gif" alt="Comune di Latina" className="ref-logo" />
              <img src="/References/Immagine16.png" alt="Cardinale" className="ref-logo" />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default References; 